<template>
  <div class="aula-modal">
    <!-- Informações do Aluno -->
    <div class="info-section">
      <h4 class="section-title">Informações do Aluno</h4>

      <div class="info-grid">
        <div class="info-item">
          <label class="info-label">Aluno</label>
          <span class="info-value">{{ aula.aluno }}</span>
        </div>

        <div class="info-item">
          <label class="info-label">RENACH</label>
          <span class="info-value">{{ aula.renach }}</span>
        </div>

        <div class="info-item">
          <label class="info-label">CPF</label>
          <span class="info-value">{{ utils.formatarCPF(aula.cpf) }}</span>
        </div>

        <div class="info-item">
          <label class="info-label">Categoria</label>
          <span class="info-value">{{ aula.categoria }}</span>
        </div>

        <div class="info-item">
          <label class="info-label">Turno</label>
          <span class="info-value">{{ aula.turno }}</span>
        </div>

        <div class="info-item">
          <label class="info-label">Data</label>
          <span class="info-value">{{ formatDate(aula.data) }}</span>
        </div>
      </div>
    </div>

    <!-- Formulário de Edição -->
    <form @submit.prevent="alterarAula" class="edit-form">
      <div class="form-section">
        <h4 class="section-title">Dados da Aula</h4>

        <div class="form-grid">
          <Select :options="veiculosFormatted" :modelValue="selectedVeiculo"
            @update:modelValue="$event => selectedVeiculo = $event" legend="Veículo" placeholder="Selecione um veículo"
            :disabled="loading" />

          <Select :options="instrutoresFormatted" :modelValue="selectedInstrutor"
            @update:modelValue="$event => selectedInstrutor = $event" legend="Instrutor"
            placeholder="Selecione um instrutor" :disabled="loading" />
        </div>

        <div class="form-grid">
          <Input legend="Hodômetro Inicial" :modelValue="aula.hodometro_inicial" readonly />
          <Input legend="Hodômetro Final" :modelValue="aula.hodometro_final" readonly />
        </div>

        <div class="form-grid">
          <InputTime legend="Início da Aula" :modelValue="aula.inicio_real"
            @update:modelValue="$event => (aula.inicio_real = $event)" :disabled="loading" />

          <InputTime legend="Fim da Aula" :modelValue="aula.fim_real"
            @update:modelValue="$event => (aula.fim_real = $event)" :disabled="loading" />
        </div>
      </div>

      <div v-if="loading" class="loading-container">
        <LoadingSpinner />
        <p>Salvando alterações...</p>
      </div>

      <div class="modal-actions">
        <Button text="Fechar" color="secondary" :fill="false" @handle:click="closeModal" :disabled="loading">
          <Close :size="18" />
        </Button>

        <Button type="submit" text="Salvar Alterações" color="primary" :disabled="loading">
          <ContentSave :size="18" />
        </Button>
      </div>
    </form>
  </div>
</template>
<script>
import Vue from 'vue'
import urlApi from '@/router/urlApiV2'
import utils from '@/services/utils.js'

// Componentes Core
import Button from 'core/Button'
import LoadingSpinner from 'core/LoadingSpinner'
import Select from 'core/Select'
import Input from 'core/Input'
import InputTime from 'core/InputTime'

// Ícones
import Close from 'icons/Close'
import ContentSave from 'icons/ContentSave'

export default {
  name: 'AulaModal',
  components: {
    Button,
    LoadingSpinner,
    Select,
    Input,
    InputTime,
    Close,
    ContentSave
  },
  props: {
    show: Boolean,
    aula: Object,
    instrutores: Array,
    veiculos: Array
  },
  data() {
    return {
      utils: utils,
      loading: false,
      selectedVeiculo: null,
      selectedInstrutor: null
    }
  },
  computed: {
    veiculosFormatted() {
      return this.veiculos.map(veiculo => ({
        value: veiculo.id,
        text: veiculo.value
      }))
    },

    instrutoresFormatted() {
      return this.instrutores.map(instrutor => ({
        value: instrutor.id,
        text: instrutor.value
      }))
    }
  },
  watch: {
    aula: {
      immediate: true,
      handler(newAula) {
        if (newAula) {
          this.selectedVeiculo = newAula.veiculoId
          this.selectedInstrutor = newAula.instrutorId
        }
      }
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return ''
      return utils.formatDate(dateString) || dateString
    },

    async alterarAula() {
      if (!this.selectedInstrutor || !this.selectedVeiculo) {
        this.$toasted.show('Selecione um instrutor e um veículo', {
          position: 'top-right',
          type: 'error'
        })
        return
      }

      if (!this.aula.inicio_real || !this.aula.fim_real) {
        this.$toasted.show('Informe o horário de início e fim da aula', {
          position: 'top-right',
          type: 'error'
        })
        return
      }

      this.loading = true

      const data = {
        aula: this.aula.aulaPraticaId,
        anotacaoPratica: this.aula.anotacaoPraticaId,
        instrutor: this.selectedInstrutor,
        inicio: this.aula.inicio_real,
        fim: this.aula.fim_real,
        veiculo: this.selectedVeiculo,
        schema: this.aula.schema,
      }

      try {
        const response = await this.$http.post(`${urlApi}/dashboard/aulas/praticas/atualizarenvio`, data)

        if (response.data.success) {
          this.$toasted.show('Aula alterada.', {
            position: 'top-right',
            type: 'success'
          })

          this.closeAndUpdateModal()
        } else {
          this.$toasted.show('Erro ao alterar aula', {
            position: 'top-right',
            type: 'error'
          })
        }
      } catch (error) {
        console.error('Erro ao alterar aula:', error)
        this.$toasted.show('Erro ao alterar aula', {
          position: 'top-right',
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },

    closeModal() {
      this.$emit('close')
    },

    closeAndUpdateModal() {
      this.$emit('closeandupdate')
    }
  }
}
</script>

<style lang="scss" scoped>
.aula-modal {
  width: 100%;
  max-width: 800px;

  @media (max-width: 768px) {
    min-width: auto;
  }

  .info-section {
    margin-bottom: 2rem;

    .section-title {
      margin: 0 0 1rem 0;
      color: #202224;
      font-size: 1.125rem;
      font-weight: 600;
      padding-bottom: 0.5rem;
      border-bottom: 2px solid #e5e7eb;
    }
  }
}

.modal-title {
  margin: 0 0 1.5rem 0;
  color: #202224;
  font-size: 1.5rem;
  font-weight: 600;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.info-section {
  margin-bottom: 2rem;

  .section-title {
    margin: 0 0 1rem 0;
    color: #202224;
    font-size: 1.125rem;
    font-weight: 600;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #e5e7eb;
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;

    @media (max-width: 992px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
      grid-template-columns: 1fr;
    }
  }

  .info-item {
    background-color: #f8fafc;
    padding: 0.75rem;
    border-radius: 0.5rem;
    border: 1px solid #e5e7eb;

    .info-label {
      display: block;
      font-size: 0.75rem;
      font-weight: 600;
      color: #6b7280;
      text-transform: uppercase;
      letter-spacing: 0.025em;
      margin-bottom: 0.25rem;
    }

    .info-value {
      font-size: 0.875rem;
      color: #374151;
      font-weight: 500;
    }
  }
}

.edit-form {
  .form-section {
    margin-bottom: 2rem;

    .section-title {
      margin: 0 0 1rem 0;
      color: #202224;
      font-size: 1.125rem;
      font-weight: 600;
      padding-bottom: 0.5rem;
      border-bottom: 2px solid #e5e7eb;
    }
  }
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1.5rem;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
}

.input-group {
  .input-legend {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.375rem;
  }

  .form-input {
    width: 100%;
    padding: 0.75rem;
    border: 2px solid #d1d5db;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    transition: all 0.2s;
    background-color: #fff;

    &:focus {
      outline: none;
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &:disabled {
      background-color: #f9fafb;
      color: #6b7280;
      cursor: not-allowed;
    }

    &[readonly] {
      background-color: #f3f4f6;
      color: #6b7280;
    }
  }
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;

  p {
    margin-top: 1rem;
    color: #6b7280;
    font-size: 0.875rem;
  }
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;

  @media (max-width: 576px) {
    flex-direction: column-reverse;
    gap: 0.75rem;
  }
}
</style>
